import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, ArrowUpRight } from "@phosphor-icons/react";
import { getBlog } from "@/lib/api";

export default function BlogTeaser() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    getBlog().then((d) => setPosts(d.slice(0, 3))).catch(() => setPosts([]));
  }, []);

  if (!posts.length) return null;

  return (
    <section id="insights" className="bg-slate-navy grain relative py-24 lg:py-32">
      <div className="relative z-10 max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-12">
          <div className="max-w-xl">
            <p className="eyebrow text-gold mb-4 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-gold" /> Insights & Education
            </p>
            <h2 className="font-heading font-extrabold tracking-tighter text-warm-white text-[clamp(2rem,4.5vw,3.4rem)] leading-[1]">
              Learn before you decide.
            </h2>
          </div>
          <Link to="/blog" data-testid="blog-view-all"
            className="inline-flex items-center gap-2 text-warm-white font-semibold text-sm hover:text-gold transition-colors">
            View all articles <ArrowRight size={16} />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          {posts.map((p, i) => (
            <motion.div key={p.slug}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.08 }}>
              <Link to={`/blog/${p.slug}`} data-testid={`blog-teaser-${i}`}
                className="group flex flex-col h-full rounded-2xl border border-white/10 bg-white/[0.03] p-7 transition-all hover:bg-white/[0.06] hover:border-gold/40">
                <p className="eyebrow text-gold/80 mb-3">{p.category}</p>
                <h3 className="font-heading font-bold text-warm-white text-xl leading-snug">{p.title}</h3>
                <p className="mt-3 text-light-slate text-sm leading-relaxed flex-1">{p.excerpt}</p>
                <span className="mt-6 flex items-center justify-between text-xs text-light-slate">
                  {p.read_time}
                  <ArrowUpRight weight="bold" size={16} className="text-gold transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
